import React from "react";
import axios from "axios";
import validator from 'validator';
import { notifications } from '@mantine/notifications';
import { Box, Group, Drawer, Button, Paper, Text, Input, TextInput, useMantineTheme, SegmentedControl, ActionIcon } from '@mantine/core';
import { IconChevronRight, IconTrash, IconPlus, IconBarcode, IconArrowLeft } from '@tabler/icons-react';

import { useLoginContext } from "../../context/loginContext";
import { BE_API_ONE, utils } from "../../utils/globalVariables";
import { regexNumberOnly, numberWithComma, removeFromArrayByIndex, isEmptyArrayObject__stockItem, changeValueOfArrayImmutable__stockItem, isDuplicateValueInArrayObject, isoDateToSqlDate, regex0to29, safeValue } from "../../utils/globalFunctions";

import InputComponent from "../../components/general/InputComponent";
import InputWrapperCustom from "../../components/general/InputWrapperCustom";
import PickerDate from "../../components/general/PickerDate";
import ModalResponse from "../../components/general/ModalResponse";
import ModalTakeAction from "../../components/general/ModalTakeAction";

import StockCategorySubSelectorDrawer from "../../components/utilities/StockCategorySubSelectorDrawer";
import SupplierSelectorDrawer from "../../components/utilities/SupplierSelectorDrawer";
import ScannerBarQRCodeModul from "../serialNumberChecker/ScannerBarQRCodeModul";

const constStockCategorySub = {
    id: 'addStockCategorySub',
    label: 'Sub Kategori',
    withAsterisk: true,
    value: {
        show: false,
        id: '',
        name: '',
        isActive: '',
        categoryId: '',
        categoryName: ''
    },
    description: '',
    error: ''
}

const StockItemAdd = ({
    stateShow,
    fnShow,
    fnSuccessAdd,
}) => {

    const mountedRef = React.useRef(true);
    const theme = useMantineTheme();
    const { loginContext, handleSetLoginContext } = useLoginContext();

    const notificationId = React.useRef({
        errorSubmitData: 'stockItemAdd-1',
        successSubmitData: 'stockItemAdd-2',
    })

    const constStockSupplier = {
        id: 'addStockSupplier',
        label: 'Supplier',
        withAsterisk: true,
        value: {
            show: false,
            id: '',
            name: '',
            address: '',
            contact: '',
            isActive: '',
        },
        description: '',
        error: '',
    }

    const constStockTanggalBeli = {
        id: 'addStockTanggalBeli',
        label: 'Tanggal Pembelian',
        withAsterisk: true,
        placeholder: 'Tanggal Pembelian',
        value: new Date(),
        description: '',
        error: ''
    }

    const constStockHargaBeli = {
        id: 'addStockHargaBeli',
        label: 'Harga Pembelian',
        withAsterisk: true,
        placeholder: 'Harga Pembelian',
        value: '',
        description: '',
        error: ''
    }

    const constStockHargaJual = {
        id: 'addStockHargaJual',
        label: 'Harga Penjualan',
        withAsterisk: true,
        placeholder: 'Harga Penjualan',
        value: '',
        description: '',
        error: ''
    }

    const constStockMasaGaransi = {
        id: 'addStockMasaGaransi',
        label: 'Masa Garansi',
        withAsterisk: true,
        placeholder: 'Masa Garansi',
        value: {
            flag: utils.masaGaransi.berjangka.value,
            bulan: '',
            hari: '',
        },
        description: '',
        error: ''
    }

    const objectStockItem = {
        serialNumber: '',
        jumlah: '',
    }

    const constStockItem = {
        id: 'addStockItem',
        label: 'STOK ITEM',
        withAsterisk: true,
        value: [],
        description: 'Jumlah otomatis terisi 1 jika item memiliki serial number',
        error: ''
    }

    const [data, setData] = React.useState({
        stockCategorySub: constStockCategorySub,
        stockSupplier: constStockSupplier,
        stockTanggalBeli: constStockTanggalBeli,
        stockHargaBeli: constStockHargaBeli,
        stockHargaJual: constStockHargaJual,
        stockMasaGaransi: constStockMasaGaransi,
        stockItem: constStockItem,

        stockItemGenerationModal: false,
        stockItemGenerationJumlah: 1,

        submitLoading: false,

        scannerModal: false,
        snKey: '',

        modalResponse: {
            show: false,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: false,
            content: ''
        }
    });

    React.useEffect(() => {
        return () => {
            mountedRef.current = false;
        }
    }, [])

    const getMasaGaransiNumber = () => {
        if (data.stockMasaGaransi.value.flag === utils.masaGaransi.berjangka.value) {
            return {
                bulan: Number(data.stockMasaGaransi.value.bulan),
                hari: Number(data.stockMasaGaransi.value.hari)
            }
        } else {
            return {
                bulan: 0,
                hari: 0
            }
        }
    }

    const resetData = () => {
        setData(d => ({
            ...d,
            stockCategorySub: constStockCategorySub,
            stockSupplier: constStockSupplier,
            stockTanggalBeli: constStockTanggalBeli,
            stockHargaBeli: constStockHargaBeli,
            stockHargaJual: constStockHargaJual,
            stockMasaGaransi: constStockMasaGaransi,
            stockItem: constStockItem,
        }))
    }

    const addData = () => {
        setData(d => ({
            ...d,
            stockCategorySub: { ...d.stockCategorySub, error: '' },
            stockSupplier: { ...d.stockSupplier, error: '' },
            stockTanggalBeli: { ...d.stockTanggalBeli, error: '' },
            stockHargaBeli: { ...d.stockHargaBeli, error: '' },
            stockHargaJual: { ...d.stockHargaJual, error: '' },
            stockMasaGaransi: { ...d.stockMasaGaransi, error: '' },
            stockItem: { ...d.stockItem, error: '' },
        }));

        if (validator.isEmpty(data.stockCategorySub.value.id, { ignore_whitespace: true })) {
            setData(d => ({ ...d, stockCategorySub: { ...d.stockCategorySub, error: 'Sub kategori wajib diisi!', } }));
        } else if (validator.isEmpty(data.stockSupplier.value.id, { ignore_whitespace: true })) {
            setData(d => ({ ...d, stockSupplier: { ...d.stockSupplier, error: 'Supplier wajib diisi!', } }));
        } else if (!validator.isDate(data.stockTanggalBeli.value)) {
            setData(d => ({ ...d, stockTanggalBeli: { ...d.stockTanggalBeli, error: 'Tanggal pembelian wajib diisi!', } }));
        } else if (validator.isEmpty(data.stockHargaBeli.value, { ignore_whitespace: true })) {
            setData(d => ({ ...d, stockHargaBeli: { ...d.stockHargaBeli, error: 'Harga pembelian wajib diisi!', } }));
        } else if (validator.isEmpty(data.stockHargaJual.value, { ignore_whitespace: true })) {
            setData(d => ({ ...d, stockHargaJual: { ...d.stockHargaJual, error: 'Harga penjualan wajib diisi!' } }))
        }

        else if ((data.stockMasaGaransi.value.flag === utils.masaGaransi.berjangka.value) && ((Number(data.stockMasaGaransi.value.bulan) === 0) && (Number(data.stockMasaGaransi.value.hari) === 0))) {
            setData(d => ({ ...d, stockMasaGaransi: { ...d.stockMasaGaransi, error: 'Masa garansi wajib diisi!' } }))
        }

        else if ((data.stockMasaGaransi.value.flag === utils.masaGaransi.berjangka.value) && ((Number(data.stockMasaGaransi.value.bulan) === 0) || Number(data.stockMasaGaransi.value.bulan) > 0) && !regex0to29({ stateData: data.stockMasaGaransi.value.hari, stateCanEmpty: true })) {
            setData(d => ({ ...d, stockMasaGaransi: { ...d.stockMasaGaransi, error: 'Masa garansi (hari) yaitu antara 0-29 hari !' } }))
        }

        else if (data.stockItem.value.length <= 0) {
            setData(d => ({ ...d, stockItem: { ...d.stockItem, error: 'Tambahkan stock item terlebih dahulu !' } }))
        } else if (isEmptyArrayObject__stockItem(data.stockItem.value, 'serialNumber', 'jumlah')) {
            setData(d => ({ ...d, stockItem: { ...d.stockItem, error: 'Lengkapi stok item terlebih dahulu atau hapus item yang kosong!' } }))
        } else if (isDuplicateValueInArrayObject(data.stockItem.value, 'serialNumber', false)) {
            setData(d => ({ ...d, stockItem: { ...d.stockItem, error: 'Oppss.. Terdapat serial number yang sama pada daftar stok item' } }));
        } else {
            setData(d => ({ ...d, submitLoading: true }));

            const formDT = new FormData();
            const formDTHeader = { 'Content-Type': 'application/json' }

            formDT.append('json_token', loginContext.syswebapp);
            formDT.append('stock_category_sub_id', data.stockCategorySub.value.id);
            formDT.append('stock_category_sub_name', data.stockCategorySub.value.name);
            formDT.append('stock_supplier', data.stockSupplier.value.id);
            formDT.append('stock_tanggal_beli', isoDateToSqlDate(data.stockTanggalBeli.value, ''));
            formDT.append('stock_harga_beli', data.stockHargaBeli.value);
            formDT.append('stock_harga_jual', data.stockHargaJual.value);

            formDT.append('stock_masa_garansi_type', data.stockMasaGaransi.value.flag);
            formDT.append('stock_masa_garansi_bulan', getMasaGaransiNumber().bulan);
            formDT.append('stock_masa_garansi_hari', getMasaGaransiNumber().hari);

            formDT.append('stock_status', utils.stockItemStatus.new.value);
            formDT.append('stock_item', JSON.stringify(data.stockItem.value.length <= 0 ? [] : data.stockItem.value));

            formDT.append('tagged_client_id', '');
            formDT.append('tagged_project_id', '');

            axios({
                method: 'post',
                url: BE_API_ONE + '/add_stock_item',
                data: formDT,
                headers: formDTHeader,
            }).then((response) => {
                if (!mountedRef.current) return null;

                setData(d => ({ ...d, submitLoading: false }));

                if (response.data.flag_status === 'isset') {

                    resetData();
                    fnSuccessAdd();

                    notifications.show({
                        id: notificationId.current.successSubmitData,
                        title: utils.notification.success.caption,
                        message: 'Berhasil Tambah Data.',
                        color: utils.notification.success.color,
                        icon: utils.notification.success.icon,
                        withBorder: true,
                        autoClose: true,
                    })
                }

                if (response.data.flag_status === 'error') {
                    notifications.show({
                        id: notificationId.current.errorSubmitData,
                        title: utils.notification.warning.caption,
                        message: response.data.pesan,
                        color: utils.notification.warning.color,
                        icon: utils.notification.warning.icon,
                        withBorder: true,
                        autoClose: true,
                    })
                }

                if (response.data.flag_status === 'duplicate-serial-number') {
                    setData(d => ({
                        ...d,
                        modalResponse: {
                            ...d.modalResponse,
                            type: utils.modalResponse.warning,
                            hideOnClickOutSide: false,
                            content: `Serial number ${response.data.suspect} sudah pernah didaftarkan pada sub kategori ${response.data.suspect_2}`,
                            show: true
                        }
                    }))
                }

                if (response.data.flag_status === 'invalid-json-token') {
                    handleSetLoginContext(null);
                }

                if (response.data.flag_status === 'user-inactive') {
                    handleSetLoginContext(null);
                }
            }).catch(error => {
                if (!mountedRef.current) return null;

                setData(d => ({ ...d, submitLoading: false }));

                notifications.show({
                    id: notificationId.current.errorSubmitData,
                    title: utils.notification.warning.caption,
                    message: error.message,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: false,
                })
            })
        }
    }

    const AllErrorBox = ({ stateArray = [] }) => {
        return (
            Object.keys(stateArray).map(key => {
                return (
                    <Text
                        key={key}
                        c={theme.colorScheme === 'light' ? theme.colors.red[6] : theme.colors.red[6]}
                        size={theme.fontSizes.sm}
                    >
                        {stateArray[key].error}
                    </Text>
                )
            })
        )
    }

    const generateKolomInput = () => {
        let arr = [];

        for (let index = 0; index < Number(data.stockItemGenerationJumlah); index++) {
            arr[index] = objectStockItem;
        }

        setData(d => ({
            ...d,
            stockItem: {
                ...d.stockItem,
                value: arr
            },
            stockItemGenerationModal: false
        }))
    }

    return (
        <React.Fragment>
            <Drawer
                opened={stateShow}
                onClose={fnShow}
                withCloseButton={false}
                position="left"
                closeOnClickOutside={true}

                title={
                    <Group noWrap spacing='xs'>
                        <ActionIcon
                            size='lg'
                            variant="light"
                            radius='xl'
                            color="blue"
                            onClick={fnShow}
                        >
                            <IconArrowLeft size='1.25rem' stroke={1.5} />
                        </ActionIcon>

                        <Text>Tambah Stok Item</Text>
                    </Group>
                }
                size='md'

                styles={() => ({
                    title: {
                        fontWeight: 'bold',
                        textTransform: 'uppercase'
                    }
                })}
            >
                <Box py='md' sx={{ minHeight: '500px' }}>
                    <Box mb='2rem'>
                        <InputWrapperCustom
                            stateLabel={data.stockCategorySub.label}
                            stateWithAsterisk={data.stockCategorySub.withAsterisk}
                            stateError={data.stockCategorySub.error}
                            stateDescription={data.stockCategorySub.description}
                        >
                            <Paper
                                sx={(tema) => ({
                                    backgroundColor: tema.colorScheme === 'light' ? '#fff' : tema.colors.dark[6],
                                    borderWidth: '1px',
                                    borderStyle: 'solid',
                                    borderColor: tema.colorScheme === 'light' ? tema.colors.gray[4] : tema.colors.dark[4],
                                    cursor: 'pointer',
                                })}

                                onClick={() => {
                                    setData(d => ({
                                        ...d,
                                        stockCategorySub: {
                                            ...d.stockCategorySub,
                                            value: {
                                                ...d.stockCategorySub.value,
                                                show: true
                                            }
                                        }
                                    }));
                                }}
                            >
                                {data.stockCategorySub.value.id === '' &&
                                    <Group
                                        position="apart"
                                        noWrap
                                        p="xs"
                                    >
                                        <Text size='sm'>Pilih Sub Kategori</Text>
                                        <IconChevronRight size="1rem" />
                                    </Group>
                                }

                                {data.stockCategorySub.value.id &&
                                    <Group
                                        position="apart"
                                        noWrap
                                        p="xs"
                                    >
                                        <Group noWrap>
                                            <Text size='sm'>
                                                <Text>
                                                    {data.stockCategorySub.value.name}
                                                </Text>

                                                <Text size='xs'>
                                                    Kategori {data.stockCategorySub.value.categoryName}
                                                </Text>

                                                <Text size='xs'>
                                                    Status Sub Kategori {data.stockCategorySub.value.isActive === '1' ? 'Aktif' : 'Non Aktif'}
                                                </Text>
                                            </Text>
                                        </Group>

                                        <IconChevronRight size="1.25rem" />
                                    </Group>
                                }
                            </Paper>
                        </InputWrapperCustom>
                    </Box>

                    <Box mb='2rem'>
                        <InputWrapperCustom
                            stateLabel={data.stockSupplier.label}
                            stateWithAsterisk={data.stockSupplier.withAsterisk}
                            stateError={data.stockSupplier.error}
                            stateDescription={data.stockSupplier.description}
                        >
                            <Paper
                                sx={(tema) => ({
                                    backgroundColor: tema.colorScheme === 'light' ? '#fff' : tema.colors.dark[6],
                                    borderWidth: '1px',
                                    borderStyle: 'solid',
                                    borderColor: tema.colorScheme === 'light' ? tema.colors.gray[4] : tema.colors.dark[4],
                                    cursor: 'pointer',
                                })}

                                onClick={() => {
                                    setData(d => ({
                                        ...d,
                                        stockSupplier: {
                                            ...d.stockSupplier,
                                            value: {
                                                ...d.stockSupplier.value,
                                                show: true
                                            }
                                        }
                                    }));
                                }}
                            >
                                {data.stockSupplier.value.id === '' &&
                                    <Group
                                        position="apart"
                                        noWrap
                                        p="xs"
                                    >
                                        <Text size='sm'>Pilih Supplier</Text>
                                        <IconChevronRight size="1rem" />
                                    </Group>
                                }

                                {data.stockSupplier.value.id &&
                                    <Group
                                        position="apart"
                                        noWrap
                                        p="xs"
                                    >
                                        <Group noWrap>
                                            <Text size='sm'>
                                                <Text>
                                                    {data.stockSupplier.value.name}
                                                </Text>

                                                <Text size='xs'>
                                                    Alamat {data.stockSupplier.value.address ? data.stockSupplier.value.address : '-'}
                                                </Text>

                                                <Text size='xs'>
                                                    Kontak {safeValue(data.stockSupplier.value.contact, '-')}
                                                </Text>

                                                <Text size='xs'>
                                                    Status Supplier {data.stockSupplier.value.isActive === '1' ? 'Aktif' : 'Non Aktif'}
                                                </Text>
                                            </Text>
                                        </Group>

                                        <IconChevronRight size="1.25rem" />
                                    </Group>
                                }
                            </Paper>
                        </InputWrapperCustom>
                    </Box>

                    <Box mb='2rem'>
                        <PickerDate
                            stateDate={data.stockTanggalBeli.value}

                            fnSetDate={(val) => setData(d => ({
                                ...d,
                                stockTanggalBeli: {
                                    ...d.stockTanggalBeli,
                                    value: val
                                }
                            }))}

                            stateMinDate={null}

                            stateLabel={data.stockTanggalBeli.label}
                            statePlaceHolder={data.stockTanggalBeli.placeholder}
                            stateWithAsterisk={data.stockTanggalBeli.withAsterisk}
                            stateDescription={data.stockTanggalBeli.description}
                            stateError={data.stockTanggalBeli.error}
                        />
                    </Box>

                    <Box mb='2rem'>
                        <InputComponent
                            stateId={data.stockHargaBeli.id}
                            stateWithAsterisk={data.stockHargaBeli.withAsterisk}
                            stateLabel={data.stockHargaBeli.label}
                            stateDescription={data.stockHargaBeli.description}
                            statePlaceHolder={data.stockHargaBeli.placeholder}
                            stateValue={numberWithComma(data.stockHargaBeli.value)}
                            stateError={data.stockHargaBeli.error}
                            stateIcon={<Text size='sm'>Rp</Text>}

                            fnOnChange={(e) => setData(d => ({
                                ...d,
                                stockHargaBeli: {
                                    ...d.stockHargaBeli,
                                    value: regexNumberOnly(e.target.value)
                                }
                            }))}
                        />
                    </Box>

                    <Box mb='2rem'>
                        <InputComponent
                            stateId={data.stockHargaJual.id}
                            stateWithAsterisk={data.stockHargaJual.withAsterisk}
                            stateLabel={data.stockHargaJual.label}
                            stateDescription={data.stockHargaJual.description}
                            statePlaceHolder={data.stockHargaJual.placeholder}
                            stateValue={numberWithComma(data.stockHargaJual.value)}
                            stateError={data.stockHargaJual.error}
                            stateIcon={<Text size='sm'>Rp</Text>}

                            fnOnChange={(e) => setData(d => ({
                                ...d,
                                stockHargaJual: {
                                    ...d.stockHargaJual,
                                    value: regexNumberOnly(e.target.value)
                                }
                            }))}
                        />
                    </Box>

                    <Box mb='2rem'>
                        <InputWrapperCustom
                            stateLabel={data.stockMasaGaransi.label}
                            stateWithAsterisk={data.stockMasaGaransi.withAsterisk}
                            stateError={data.stockMasaGaransi.error}
                            stateDescription={data.stockMasaGaransi.description}
                        >
                            <SegmentedControl
                                fullWidth
                                value={data.stockMasaGaransi.value.flag}
                                onChange={(val) => setData(d => ({
                                    ...d,
                                    stockMasaGaransi: {
                                        ...d.stockMasaGaransi,
                                        value: {
                                            ...d.stockMasaGaransi.value,
                                            flag: val
                                        }
                                    }
                                }))}

                                data={Object.values(utils.masaGaransi).map(key => ({ value: key.value, label: key.caption }))}
                            />
                        </InputWrapperCustom>

                        {data.stockMasaGaransi.value.flag === utils.masaGaransi.berjangka.value &&
                            <Group noWrap spacing='xs'>
                                <InputComponent
                                    stateId={data.stockMasaGaransi.id + '-input-bulan'}
                                    stateWithAsterisk={false}
                                    stateLabel=''
                                    stateDescription=''
                                    statePlaceHolder='0'
                                    stateValue={data.stockMasaGaransi.value.bulan}
                                    stateError=''
                                    stateStylesInput={{
                                        paddingRight: '3.25rem'
                                    }}
                                    stateRightSection={<Text
                                        size='sm'
                                        sx={{ paddingRight: '1.25rem', opacity: .5 }}
                                    >
                                        Bulan
                                    </Text>}

                                    stateMT="xs"

                                    fnOnChange={(e) => setData(d => ({
                                        ...d,
                                        stockMasaGaransi: {
                                            ...d.stockMasaGaransi,
                                            value: {
                                                ...d.stockMasaGaransi.value,
                                                bulan: regexNumberOnly(e.target.value)
                                            }
                                        }
                                    }))}
                                />

                                <InputComponent
                                    stateId={data.stockMasaGaransi.id + '-input-hari'}
                                    stateWithAsterisk={false}
                                    stateLabel=''
                                    stateDescription=''
                                    statePlaceHolder='0'
                                    stateValue={data.stockMasaGaransi.value.hari}
                                    stateError=''
                                    stateStylesInput={{
                                        paddingRight: '3.25rem'
                                    }}
                                    stateRightSection={<Text
                                        size='sm'
                                        sx={{ paddingRight: '1.25rem', opacity: .5 }}
                                    >
                                        Hari
                                    </Text>}

                                    stateMT="xs"

                                    fnOnChange={(e) => {
                                        setData(d => ({
                                            ...d,
                                            stockMasaGaransi: {
                                                ...d.stockMasaGaransi,
                                                value: {
                                                    ...d.stockMasaGaransi.value,
                                                    hari: regexNumberOnly(e.target.value)
                                                }
                                            }
                                        }));
                                    }}
                                />
                            </Group>
                        }
                    </Box>

                    {/* batas */}

                    <Box mb='2rem'>
                        <InputWrapperCustom
                            stateLabel={data.stockItem.label}
                            stateWithAsterisk={data.stockItem.withAsterisk}
                            stateError={data.stockItem.error}
                            stateErrorMT={0}
                            stateErrorSX={{ marginBottom: '0.75rem' }}
                            stateDescription={data.stockItem.value.length > 0 ? data.stockItem.description : 'Input serial number dan jumlah item'}
                        >
                            {Object.keys(data.stockItem.value).map((key, index) => {
                                return (
                                    <Box
                                        key={key}
                                        mb='1rem'

                                        p='xs'

                                        sx={(tema) => ({
                                            backgroundColor: tema.colorScheme === 'light' ? tema.colors.gray[0] : tema.colors.dark[6],
                                            borderRadius: tema.radius.sm,
                                            borderWidth: '1px',
                                            borderStyle: 'solid',
                                            borderColor: tema.colorScheme === 'light' ? tema.colors.gray[4] : tema.colors.dark[4],
                                        })}
                                    >
                                        <Input.Wrapper
                                            id={data.stockItem.id + '-sn-' + key}
                                            size='sm'
                                            withAsterisk={false}
                                            labelProps={{ style: { width: '100%' } }}
                                            label={
                                                <Group position="apart">
                                                    <Text color="dimmed">Serial Number ({Number(index) + 1})</Text>

                                                    {/* {Number(key) === 0 ? null : */}
                                                    <IconTrash
                                                        size='1rem'
                                                        style={{ cursor: 'pointer', opacity: 0.75 }}

                                                        onClick={() => setData(d => ({
                                                            ...d,
                                                            stockItem: {
                                                                ...d.stockItem,
                                                                value: removeFromArrayByIndex(key, data.stockItem.value)
                                                            }
                                                        }))}
                                                    />
                                                    {/* } */}
                                                </Group>
                                            }
                                            description=''
                                            sx={{ marginBottom: '.75rem' }}
                                        >
                                            <TextInput
                                                id={data.stockItem.id + '-sn-' + key}
                                                variant='default'
                                                placeholder='Serial Number'
                                                value={data.stockItem.value[key].serialNumber}
                                                onChange={(e) => setData(d => ({
                                                    ...d,
                                                    stockItem: {
                                                        ...d.stockItem,
                                                        value: changeValueOfArrayImmutable__stockItem(d.stockItem.value, key, 'serialNumber', e.target.value, 'serialNumber', 'jumlah')
                                                    }
                                                }))}

                                                rightSection={
                                                    <ActionIcon
                                                        onClick={() => setData(d => ({ ...d, scannerModal: true, snKey: key }))}

                                                        color='blue'
                                                        variant='filled'
                                                    >
                                                        <IconBarcode size="1rem" style={{ display: 'block', opacity: 1 }} />
                                                    </ActionIcon>
                                                }

                                                styles={(tema) => ({
                                                    input: {
                                                        backgroundColor: tema.colorScheme === 'light' ? '#fff' : tema.colors.dark[7],
                                                    }
                                                })}
                                            />
                                        </Input.Wrapper>

                                        <Input.Wrapper
                                            id={data.stockItem.id + '-jml-' + key}
                                            size='sm'
                                            withAsterisk={false}
                                            label={<Text color="dimmed">Jumlah</Text>}
                                            description=''
                                        >
                                            <TextInput
                                                id={data.stockItem.id + '-jml-' + key}
                                                variant='default'
                                                placeholder='Jumlah'
                                                value={data.stockItem.value[key].jumlah}
                                                onChange={(e) => setData(d => ({
                                                    ...d,
                                                    stockItem: {
                                                        ...d.stockItem,
                                                        value: changeValueOfArrayImmutable__stockItem(d.stockItem.value, key, 'jumlah', e.target.value, 'serialNumber', 'jumlah')
                                                    }
                                                }))}

                                                styles={(tema) => ({
                                                    input: {
                                                        backgroundColor: tema.colorScheme === 'light' ? '#fff' : tema.colors.dark[7],
                                                    }
                                                })}
                                            />
                                        </Input.Wrapper>
                                    </Box>
                                )
                            })}
                        </InputWrapperCustom>

                        {data.stockItem.value.length > 0 &&
                            <Group
                                spacing={5}
                                px='xs'
                                py='0.25rem'
                                position="apart"

                                sx={(tema) => ({
                                    borderWidth: '1px',
                                    borderStyle: 'dashed',
                                    borderColor: tema.colorScheme === 'light' ? tema.colors.blue[6] : tema.colors.blue[6],
                                    borderRadius: tema.radius.sm,
                                    color: tema.colorScheme === 'light' ? tema.colors.blue[6] : tema.colors.blue[6],
                                    cursor: 'pointer',
                                    '&:hover': {
                                        backgroundColor: tema.colorScheme === 'light' ? tema.fn.rgba(tema.colors.blue[3], 0.1) : tema.fn.rgba(tema.colors.blue[9], 0.1),
                                    }
                                })}

                                onClick={() => setData(d => ({
                                    ...d,
                                    stockItem: {
                                        ...d.stockItem,
                                        value: [...d.stockItem.value, objectStockItem]
                                    }
                                }))}
                            >
                                <Text size='sm'>Item : {Object.keys(data.stockItem.value).length}</Text>

                                <Group noWrap spacing={3}>
                                    <IconPlus size='0.8rem' />
                                    <Text size='sm'>Tambah Item</Text>
                                </Group>
                            </Group>
                        }

                        {data.stockItem.value.length <= 0 &&
                            <Group
                                spacing={5}
                                mt='sm'
                                px='xs'
                                py='0.5rem'
                                position='center'

                                sx={(tema) => ({
                                    borderWidth: '1px',
                                    borderStyle: 'dashed',
                                    borderColor: tema.colorScheme === 'light' ? tema.colors.blue[6] : tema.colors.blue[6],
                                    borderRadius: tema.radius.sm,
                                    color: tema.colorScheme === 'light' ? tema.colors.blue[6] : tema.colors.blue[6],
                                    cursor: 'pointer',
                                    '&:hover': {
                                        backgroundColor: tema.colorScheme === 'light' ? tema.fn.rgba(tema.colors.blue[3], 0.1) : tema.fn.rgba(tema.colors.blue[9], 0.1),
                                    }
                                })}

                                onClick={() => setData(d => ({
                                    ...d,
                                    stockItemGenerationModal: true
                                }))}
                            >
                                <Group noWrap spacing={3}>
                                    <IconPlus size='0.8rem' />
                                    <Text size='sm'>Tambahkan Item</Text>
                                </Group>
                            </Group>
                        }
                    </Box>

                    <Box mb='2rem'>
                        <AllErrorBox
                            stateArray={[
                                data.stockCategorySub,
                                data.stockSupplier,
                                data.stockTanggalBeli,
                                data.stockHargaBeli,
                                data.stockHargaJual,
                                data.stockMasaGaransi,
                            ]}
                        />
                    </Box>

                    <Group position="apart" noWrap spacing='xs' my='xl'>
                        <Button
                            fullWidth
                            variant="default"
                            color='gray'
                            onClick={resetData}
                        >
                            Reset
                        </Button>

                        <Button
                            fullWidth
                            // variant="default"
                            // color='teal'
                            loading={data.submitLoading}
                            onClick={addData}
                        >
                            Submit
                        </Button>
                    </Group>

                </Box>
            </Drawer>

            <StockCategorySubSelectorDrawer
                stateShow={data.stockCategorySub.value.show}

                fnShow={() => setData(d => ({
                    ...d,
                    stockCategorySub: {
                        ...d.stockCategorySub,
                        value: {
                            ...d.stockCategorySub.value,
                            show: false
                        }
                    }
                }))}

                stateData={{
                    categoryId: utils.flagAll,
                    categoryIsActive: '1'
                }}

                fnOnSelect={(object) => setData(d => ({
                    ...d,
                    stockCategorySub: {
                        ...d.stockCategorySub,
                        value: {
                            ...d.stockCategorySub.value,
                            id: object.stockCategorySubId,
                            name: object.stockCategorySubName,
                            isActive: object.stockCategorySubIsActive,
                            categoryId: object.stockCategoryId,
                            categoryName: object.stockCategoryName,
                            show: false
                        }
                    }
                }))}
            />

            <SupplierSelectorDrawer
                stateShow={data.stockSupplier.value.show}

                fnShow={() => setData(d => ({
                    ...d,
                    stockSupplier: {
                        ...d.stockSupplier,
                        value: {
                            ...d.stockSupplier.value,
                            show: false
                        }
                    }
                }))}

                stateData={{
                    supplierIsActive: '1'
                }}

                fnOnSelect={(object) => {
                    setData(d => ({
                        ...d,
                        stockSupplier: {
                            ...d.stockSupplier,
                            value: {
                                ...d.stockSupplier.value,
                                id: object.supplierId,
                                name: object.supplierName,
                                address: object.supplierAddress,
                                contact: object.supplierContact,
                                isActive: object.supplierIsActive,
                                show: false
                            }
                        }
                    }))
                }}
            />

            <ModalResponse
                stateShow={data.modalResponse.show}
                fnHide={() => setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        show: false
                    }
                }))}

                stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
                stateType={data.modalResponse.type}
                stateContent={data.modalResponse.content}
            />

            <ModalTakeAction
                stateShow={data.stockItemGenerationModal}
                fnHide={() => setData(d => ({ ...d, stockItemGenerationModal: false }))}

                stateHideOnClickOutSide={true}
                stateTitle={String('Input Data').toUpperCase()}
                stateOverlayZIndex={201}

                stateButtonClosePx='md'

                stateButtonActionCaption='Submit'
                stateButtonActionPx='xs'
                stateButtonActionColor=""
                stateButtonActionLoading={false}
                fnButtonAction={generateKolomInput}
            >
                <InputComponent
                    stateId='input-jumlah-item-id'
                    stateWithAsterisk={false}
                    stateLabel='Masukkan Jumlah Kolom Input'
                    stateDescription=''
                    statePlaceHolder='Jumlah Item'
                    stateValue={data.stockItemGenerationJumlah}
                    stateError=''

                    fnOnChange={(e) => setData(d => ({
                        ...d,
                        stockItemGenerationJumlah: regexNumberOnly(e.target.value)
                    }))}
                />
            </ModalTakeAction>

            <ScannerBarQRCodeModul
                stateData={{
                    show: data.scannerModal,
                }}

                fnSuccess={(val) => {
                    setData(d => ({
                        ...d,
                        stockItem: {
                            ...d.stockItem,
                            value: changeValueOfArrayImmutable__stockItem(d.stockItem.value, d.snKey, 'serialNumber', val, 'serialNumber', 'jumlah')
                        },
                        scannerModal: false
                    }))
                }}

                fnClose={(val) => setData(d => ({ ...d, scannerModal: val }))}

                fnFailed={(val) => { }}
            />
        </React.Fragment>
    )
}

export default StockItemAdd;